import { bindQueryParams } from "src/helpers/tools";
import { methods, request } from "./base";

const goalsApis = {
  getGoals: async (queryParams: { user_id: string }) => {
    const route = bindQueryParams("/gfc/goals/user-goals", queryParams);
    return await request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
  setGoals: async (payload: object) => {
    return await request({
      method: methods.POST,
      route: "/gfc/goals",
      priv: true,
      encrypt: false,
      payload,
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};

export default goalsApis;
